import { render, staticRenderFns } from "./elo.vue?vue&type=template&id=f713e7cc&scoped=true"
var script = {}
import style0 from "./elo.vue?vue&type=style&index=0&id=f713e7cc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f713e7cc",
  null
  
)

export default component.exports